import { render, staticRenderFns } from "./CreateSteadReceiveInterDocu.vue?vue&type=template&id=0064bb24&scoped=true&"
import script from "./CreateSteadReceiveInterDocu.vue?vue&type=script&lang=js&"
export * from "./CreateSteadReceiveInterDocu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064bb24",
  null
  
)

export default component.exports